import React from 'react';
import { useAuth } from '@/context/AuthContext';

interface CanAccessProps {
  roles: string[];
  children: React.ReactNode;
  /** When true, renders nothing instead of throwing/redirecting. Default: true */
  silent?: boolean;
}

/**
 * Renders children only when the current user's role is in the `roles` list.
 * Usage:
 *   <CanAccess roles={['admin', 'qa_director']}>
 *     <button>Delete Lab</button>
 *   </CanAccess>
 */
export default function CanAccess({ roles, children, silent = true }: CanAccessProps) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) {
    return silent ? null : <></>;
  }
  return <>{children}</>;
}

/** Hook form — returns boolean for imperative checks */
export function useCanAccess(roles: string[]): boolean {
  const { user } = useAuth();
  return !!user && roles.includes(user.role);
}
